import type { EChartsOption } from 'echarts';
import { EChart } from './EChart';

interface CandlestickChartProps {
  categories: string[];
  data: Array<[number, number, number, number]>;
  height?: number | string;
  loading?: boolean;
}

export function CandlestickChart({ categories, data, height, loading }: CandlestickChartProps) {
  const option: EChartsOption = {
    tooltip: { trigger: 'axis' },
    grid: { left: 50, right: 20, top: 20, bottom: 40, containLabel: true },
    xAxis: { type: 'category', data: categories },
    yAxis: { type: 'value' },
    series: [{ type: 'candlestick', data, itemStyle: { color: '#10b981', color0: '#ef4444', borderColor: '#10b981', borderColor0: '#ef4444' } }],
  };
  return <EChart option={option} height={height} loading={loading} />;
}
